import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-secondary-600 font-medium tracking-wide uppercase mb-2">
            内容导航
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索更多内容
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            按类别浏览安斋拉拉相关内容，找到你最感兴趣的话题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 hover:bg-background-100/70 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex-shrink-0 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1.5">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {cat.count}篇
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}